<template>
    <Dialog v-model:visible="visible" modal :header="$t('buttons.contactUsLong')">
        <div class="errMsg" v-if="submitStatus">
            <Message v-if="!submitStatus.success" severity="error" icon="pi pi-times-circle" :life="5000">{{submitStatus.message}}</Message>
            <Message v-if="submitStatus.success" severity="success" icon="pi pi-check-circle" :life="5000">{{submitStatus.message}}</Message>
        </div>
        <div style="display: flex; flex-direction: column; row-gap: 12px;">
            <InputText type="text" v-model="name" variant="filled" :placeholder="$t('contact.form.name')" />
            <InputText type="text" v-model="business" variant="filled" :placeholder="$t('contact.form.business')" />
            <InputText type="text" v-model="mobile" variant="filled" :placeholder="$t('contact.form.mobile')" />
            <InputText type="text" v-model="email" variant="filled" :placeholder="$t('contact.form.email')" />
            <Textarea v-model="message" variant="filled" rows="5" cols="30" :placeholder="$t('contact.form.message')" />
            <Button @click="submitForm()" :label="$t('contact.form.send')" severity="contrast" icon="pi pi-envelope"  />
        </div>
    </Dialog>
</template>
  
<script>
import Button from 'primevue/button'
import Dialog from 'primevue/dialog';
import InputText from 'primevue/inputtext';
import Textarea from 'primevue/textarea';

import Message from 'primevue/message';
export default {
    name: 'contactPopup',
    components: {
        Button,
        Dialog,
        InputText,
        Textarea,
        Message
    },
    props: {
        currentLang: null
    },
    data() {
        return {
            visible: false,
            showError: false,
            name: null,
            business: null,
            mobile: null,
            email: null,
            message: null,
            submitStatus: null,
            loading: false
        };
    },
    computed: {
      
    },
    methods: {
        async submitForm() {
            // Validate form
            if (!this.name || !this.email || !this.message) {
                this.submitStatus = {
                    success: false,
                    message: this.$t('contact.form.validation', this.currentLang) || 'Palun sisesta nimi, email ja sõnum'
                };
                return;
            }
            this.loading = true
            this.submitStatus = null
            
            try {
                const contactData = {
                    lang: this.currentLang,
                    name: this.name,
                    email: this.email,
                    phone: this.mobile,
                    business: this.business,
                    message: this.message
                };
                
                const response = await fetch('/api/contact', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(contactData)
                });
                
                const result = await response.json();
                
                if (result.success) {
                    this.name = '',
                    this.business = '',
                    this.email = '',
                    this.mobile = '',
                    this.message = ''
                }
                
                this.submitStatus = {
                    success: result.success,
                    message: result.message
                };
            } catch (error) {
                console.error('Viga sõnumi saatmisel:', error);
                this.submitStatus = {
                    success: false,
                    message: this.$t('contact.form.error', this.currentLang) || 'Viga sõnumi saatmisel. Palun proovi uuesti hiljem.'
                };
            } finally {
                this.loading = false;
            }
        },
    },
    created() {
        

    },
    mounted() {
      // Lifecycle hook - called after the component is mounted to the DOM
    
    },
    updated() {
      // Lifecycle hook - called after a data change causes the DOM to re-render
    
    },
  };
</script>
<style>
.errMsg .p-message-text {
    text-align: start;
}
</style>
<style scoped>
.errMsg {
    margin-top: 5px;
    margin-bottom: 10px;
}
.bar {
    width: 100%;
    padding-bottom: 10px;
    padding-top: 10px;
    position: fixed;
    z-index: 1200;
    bottom: 0;
    background: white;
}
.bar h2 {
    margin: 0;
    margin-top: auto;
    position: absolute;
    left: 140px;
    bottom: -6px;
    color: rgb(173, 194, 214);
    font-size: 24px;
}
.bar img {
    margin-left: -4px;
}
h1 {
    position: absolute;
    right: 0;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    font-size: 24px;
    color: steelblue;
}
.navBody {
    position: relative;
    width: 1300px;
    margin: 0 auto;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
}
@media (max-width: 1340px) {
    .navBody {
        width: 100%;
        padding-left: 20px;
        padding-right: 20px;
    }
    h1 {
        position: relative;
    }
}
@media (max-width: 750px) {
    h1 {
        font-size: 3.5vw;
        text-align: end;
    }
    img {
        margin-right: 20px;
    }
}
</style>